<template>
    <el-date-picker size="small"
      v-model="time"
      type="datetime" 
      :clearable="true"
      :placeholder="placeholder"
      :picker-options="pickerOptions">
    </el-date-picker>
</template>

<script>
  export default {
  	name: 'datetime',
    data() {
      return {
        time: '',
        placeholder: '选择日期时间',
        pickerOptions: {
          shortcuts: [{
            text: '明天',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', start);
            }
          }, {
            text: '后天',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', start);
            }
          }, {
            text: '一周后',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', start);
            }
          }, {
            text: '一月后',
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit('pick', start);
            }
          }]
        }
      }
    },
    props: {
      defaultTime: String,
      defaultPlaceholder: String
    },
  	computed: {
  		getTime () {
  			let time = {}
  			time = this.time
          	?this.$moment(this.time)
              .format('YYYY-MM-DD HH:mm:ss')
            :''
  			return time
  		}
    },
    watch: {
        defaultTime(oldVal,newVal) {
            this.time = this.defaultTime?new Date(this.defaultTime):''
        }
    },
    mounted () {
        this.time = this.defaultTime?new Date(this.defaultTime):''
        this.defaultPlaceholder
        ?this.placeholder = this.defaultPlaceholder
        :''
    },
    methods: {
        init() {
          this.time = this.defaultTime?new Date(this.defaultTime):''
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/datetime.vue